import { ApiConnector } from '@/integrations/api.connector';

import {
  type TFaqRequest,
  type TFaqResponse
} from '../../Shared/widgets/faq-main-page/types/faq.types';

class FaqApi extends ApiConnector {
  private baseUrl = 'faq';

  public async getAllFaq(): Promise<TFaqResponse[]> {
    return this.call({
      path: this.baseUrl
    });
  }

  public async getFaqArticle(faqId: string): Promise<TFaqResponse> {
    return this.call({
      path: `${this.baseUrl}/${faqId}`
    });
  }

  public async createFaq(body: TFaqRequest) {
    return this.call<TFaqRequest, TFaqResponse>({
      path: this.baseUrl,
      method: 'post',
      body
    });
  }

  public async updateFaq(uuid: string, body: TFaqRequest) {
    return this.call<TFaqRequest, TFaqResponse>({
      path: `${this.baseUrl}/${uuid}`,
      method: 'patch',
      body
    });
  }
}

export const faqApi = new FaqApi();
